import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import AcceptInvite from './components/auth/AcceptInvite'
import ForgotPassword from './components/auth/ForgotPassword'
import Login from './components/auth/Login'
import Register from './components/auth/register.js/Register'
import Onboarding from './components/auth/Onboarding'
import ResetPassword from './components/auth/ResetPassword'
import Dashboard from './components/Dashboard'
import PostHogPageviewTracker from './components/utils/PostHogPageViewTracker'
import CreateOrganization from './components/auth/CreateOrganization'
import FrontRouteGuard from './components/guards/FrontRouteGuard'
import ProtectedRoute from './components/guards/ProtectedRoute'
import SubscriptionEnded from './components/auth/SubscriptionEnded'
import NotFound from './components/dashboard/NotFound'
import {
  setOrganizationUpdateListener,
  clearOrganizationUpdateListener,
  runSubscriptionGate,
} from './utils/organizationService'

const Main = () => {
  const [organization, setOrganization] = useState(
    localStorage.getItem("organization") ? JSON.parse(localStorage.getItem("organization")) : null
  );

  useEffect(() => {
    setOrganizationUpdateListener(setOrganization);
    return () => clearOrganizationUpdateListener();
  }, []);

  useEffect(() => {
    if (!organization) return;
    runSubscriptionGate(organization, { pathname: window.location.pathname });
  }, [organization]);
  return (   
   <>      
    <BrowserRouter>
      <PostHogPageviewTracker/>
      <FrontRouteGuard>
        <Routes>
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard/></ProtectedRoute>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/accept-invite/:token" element={<AcceptInvite/>} />
          <Route path="/create-organization/" element={<CreateOrganization/>} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/reset-password/:data" element={<ResetPassword/>} />
          <Route path="/register" element={<Register/>} />
          <Route path="/onboarding" element={<Onboarding/>} />
          <Route path="/" element={<Login/>} />
          <Route path='/subscription-ended' element={<SubscriptionEnded/>} />
          <Route path='/*' element={<NotFound/>} />
        </Routes>
      </FrontRouteGuard>
    </BrowserRouter>
   </>
  )
}

export default Main